import { Button, Grid, Paper, insetShadow } from '@alice-financial/pretext-ui'
import * as React from 'react'
import SignaturePadController from 'signature_pad'

export type SignaturePadRef = {
  canvas: HTMLCanvasElement
  signaturePad: SignaturePadController | null
}
const useHookWithRefCallback = (getRef: (ref: SignaturePadRef) => void) => {
  const ref = React.useRef<SignaturePadRef | null>(null)
  const setRef = React.useCallback(
    (node: HTMLCanvasElement) => {
      // remove event listeners from previous canvas
      if (ref.current) ref.current.signaturePad?.off()

      // create new signature pad on new canvas
      const signaturePad = node
        ? new SignaturePadController(node, { dotSize: 1, minWidth: 1, maxWidth: 2 })
        : null

      ref.current = { canvas: node, signaturePad }
      getRef(ref.current)
    },
    [getRef]
  )

  return [ref, setRef] as const
}

export const SignaturePad = ({ getRef }: { getRef: (ref: SignaturePadRef) => void }) => {
  const [ref, setRef] = useHookWithRefCallback(getRef)
  const clearSignature = () => {
    ref.current?.signaturePad?.clear()
  }

  return (
    <Grid container flexDirection="column" gap={2}>
      <Paper
        sx={{
          width: 400,
          height: 200,
          boxShadow: (theme) => insetShadow(theme.shadows[2]),
          position: 'relative',
        }}
      >
        <canvas ref={setRef} width={400} height={200} />
        <Button
          size="small"
          variant="outlined"
          onClick={clearSignature}
          sx={{ position: 'absolute', bottom: 10, right: 10 }}
        >
          Clear
        </Button>
      </Paper>
    </Grid>
  )
}
